import { useEffect, useState } from "react";
import axios from "axios";

export default function useMeta(pageKey) {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!pageKey || typeof pageKey !== "string") return;
    console.log("API DOMAIN:", process.env.REACT_APP_APP_DOMAIN);

    const baseURL = process.env.REACT_APP_APP_DOMAIN;

    axios
      .get(`${baseURL}/api/meta/${encodeURIComponent(pageKey)}`)
      .then(res => setMeta(res.data))
      .catch(err => console.error("Meta API error:", err));

  }, [pageKey]);

  return meta;
}
